module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<section class="draw-wrap J_draw">\r\n    <div class="draw-header">\r\n        <div class="tab-wrap">\r\n            <ul class="tab-list">\r\n                <li class="tab-item active">{{title}}</li>\r\n            </ul>\r\n        </div>\r\n        <p class="close-btn">关闭</p>\r\n    </div>\r\n    <div class="draw-body">\r\n        <ul class="sig-list J_sig-list">\r\n        \r\n            {{signList}}\r\n        </ul>\r\n    </div>\r\n</section>\r\n';

}
return __p
}